import { PATHNAMES } from 'constants/constants';

export const BRANCH_DEPLOYMENTS_ENABLED = import.meta.env.VITE_ENABLE_BRANCH_DEPLOYMENTS?.toLowerCase() === 'true';

export const BRANCH_URL_PARAM = 'branch';

export const getBranchDeploymentUrl = (branch: string) =>
  `${window.location.origin}${PATHNAMES.developerPanel}/branches?${BRANCH_URL_PARAM}=${encodeURIComponent(branch)}`;
